import React from 'react';
import {
  Alert,
  Box,
  Button,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { canAccessLegacyBuilders, getExperienceLabel, getV2PublicOrigin } from '../config/domainExperience';

function DomainRouteGate({ children, requireLegacy = false }) {
  if (requireLegacy && !canAccessLegacyBuilders()) {
    const v2Origin = getV2PublicOrigin();
    return (
      <Box sx={{ p: 3 }}>
        <Paper sx={{ p: 3 }}>
          <Stack spacing={2}>
            <Typography variant="h5">Legacy builder is not available on this domain</Typography>
            <Alert severity="info">
              Current environment: {getExperienceLabel()}. Open legacy builders on `chat.baiglabs.com`, or use V2 Studio on `{v2Origin}`.
            </Alert>
            <Button component={RouterLink} to="/studio" variant="contained">
              Open V2 Studio
            </Button>
            <Button component={RouterLink} to="/dashboard" variant="outlined">
              Back to dashboard
            </Button>
          </Stack>
        </Paper>
      </Box>
    );
  }

  return children;
}

export default DomainRouteGate;
